import { MobileOfferCatalogEntry, MobileOfferProvider } from '@numeo/types'
import { MobilePlan } from '@numeo/types-core'
import { offerPlans, planLabels, storeLabels } from './offerLabels'

export const customerOfferPlans = offerPlans.map((value) => ({ value, label: planLabels[value] }))

export function customerPlanName(plan: MobilePlan): string {
    return planLabels[plan]
}

export function customerStoreName(provider: MobileOfferProvider): string {
    return storeLabels[provider]
}

export function customerOfferLabel(offer: MobileOfferCatalogEntry): string {
    return `${customerPlanName(offer.terms.plan)} · ${offer.terms.percentOff}% off · ${offer.terms.discountedPeriods} monthly payments`
}

export function normalizeCustomerIdentity(value: string): string {
    const identity = value.trim()
    return identity.includes('@') ? identity.toLowerCase() : identity.replace(/[\s().-]/g, '')
}

export function isExactCustomerIdentity(value: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || /^\+[1-9]\d{7,14}$/.test(value)
}

export function customerOfferDate(value: string): string {
    const date = new Date(value)
    return Number.isFinite(date.getTime()) ? date.toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' }) : 'Unavailable'
}

export function customerDeadlineDefault(): string {
    const date = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
    return new Date(date.getTime() - date.getTimezoneOffset() * 60_000).toISOString().slice(0, 16)
}

export const customerOfferLinkClass =
    'inline-flex items-center gap-2 rounded-md text-sm font-medium text-blue-600 dark:text-blue-400 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600'

export const customerOfferSecondaryClass = 'text-sm text-slate-500 dark:text-slate-400'
